export default __webpack_public_path__ + "static/media/borderless.c3332202.svg";